export enum EventDetailsComponentType {
  EDIT,
  COPY,
  ADD
}
